<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">充值</span>
            </template>
            <template #left>
                <router-link to="/">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

<!--        <van-tabs v-model="learn_type" @click="getProducts">-->
<!--            <van-tab title="模拟考试" name="1"></van-tab>-->
<!--            <van-tab title="课程学习" name="2"></van-tab>-->
<!--        </van-tabs>-->


        <van-tabs v-model="form_type" @click="getProducts">
            <van-tab title="直接支付" name="1"></van-tab>
            <van-tab title="代充值" name="2"></van-tab>
            <van-tab title="绑定充值号" name="3"></van-tab>
        </van-tabs>

        <van-row v-show="form_type != 2">
            <current-subject ref="subject"></current-subject>
            <van-cell title="">
                <template #title>
                    <span style="color: red">请注意：充值仅对当前科目有效，付款后不能更改科目，也不支持退款</span>
                </template>
            </van-cell>
        </van-row>

        <van-row v-show="form_type == 2">
            <van-cell-group>
                <van-cell title="代充是替别人付款, 不需要选科目, 付款后系统会返回充值号, 由真正使用的人在'绑定充值号'的时候选择科目"/>
                <van-field v-model="quantity" type="digit" label-width="50px" label="数量:"/>
            </van-cell-group>
        </van-row>

        <van-row v-show="form_type != 3">
            <van-grid :border="false" :column-num="2" :gutter="8">
                <van-grid-item v-for="(product,index) in products" :key="product.id">
                    <van-tag plain size="large" type="success" @click="toBuy(product.id,index)">{{product.title}}<br>{{product.amount}}元
                    </van-tag>
                </van-grid-item>
            </van-grid>
        </van-row>



        <van-row v-show="form_type == 3">

            <van-field v-model="number" label="卡号:" label-width="50px"/>
            <van-cell>
                <van-button :loading="payLoading" type="info" size="small" block @click="bindingCdKey">绑定</van-button>
            </van-cell>
        </van-row>


        <br>
        <van-row>
            <van-cell-group>
              <van-cell is-link to="/my/orders">
                我的订单-人工确认
              </van-cell>
                <van-cell>
                    温馨提示：<br>
                    不同的套餐只是有效时间上有区别, 在有效期内可以使用所有功能及科目所有试题, 并且不限次数。<br>
                    如果付款完成, 但系统没有显示充值成功 (系统由于网络原因没有及时得到微信服务器的通知), 请务必在公众号内给我们留言，且一定要带上微信的支付单号或者商户单号, 我们将人工确认您的充值。
                </van-cell>

            </van-cell-group>
        </van-row>


        <van-dialog v-model="payLoading" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{payLoadingText}}</van-loading>
            <br>
        </van-dialog>


        <van-dialog v-model="buyConfirmModel" title="确认购买"
                    show-cancel-button
                    confirm-cancel-text="放弃"
                    @confirm="toPay"
                    @cancel="buyConfirmModel=false"
                    confirm-button-text="继续充值">

            <div style="padding: 0 10px">
                <p>套餐名称：{{product.title}}</p>
                <p>充值科目：{{current_subject_name}}</p>
                <p style="color: red">
                    注意：<br>
                    1、充值仅针对当前科目，请仔细核对<br>
                    2、有任何问题，请在公众号内给我们留言<br>
                </p>
            </div>
        </van-dialog>

    </div>
</template>

<script>
    import CurrentSubject from "@/components/CurrentSubject.vue"
    import wx from "weixin-js-sdk";

    export default {
        components:{
            CurrentSubject
        },
        data() {
            return {
                active: 0,
                products: [],

                form_type: 1,
                learn_type: 1,

                quantity: 1,
                product_id:0,
                product:{},

                number: "",

                payLoading: false,
                payLoadingText: "加载中...",

                buyConfirmModel:false,
                timer_pay_info: '',

                current_subject_name:'',//当前选择科目
            };
        },
        beforeDestroy() {
            clearInterval(this.timer_pay_info);
        },
        created() {
            this.wxConfig()
            this.getProducts()
        },
        methods: {
            getProducts() {
                this.products = [];
                if (this.form_type >= 3) {
                    return
                }
                this.$http.get("/wechat/products", {
                    params: {
                        form_type: this.form_type,
                        learn_type: this.learn_type,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (200 === res.data.code) {
                        this.products = res.data.data
                    }
                });
            },
            wxConfig() {
                this.$http.post("/wechat/js_config", {url: window.location.href}).then(res => {
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        //
                        return
                    }
                    console.log(res.data.data)
                    console.log("开始")
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.data.app_id, // 必填，公众号的唯一标识
                        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.data.nonce_str, // 必填，生成签名的随机串
                        signature: res.data.data.signature,// 必填，签名
                        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
                    });

                });
            },

            toBuy(product_id,index){
                this.current_subject_name=this.$refs.subject.user.subject_name
                this.product_id=product_id
                this.product=this.products[index]
                if (1==this.form_type){
                    this.buyConfirmModel=true
                }else {
                    this.toPay()
                }
            },

            toPay() {
                this.payLoading = true
                this.$http.get("/wechat/buy", {
                    params: {
                        product_id: this.product_id,
                        quantity: this.quantity
                    }
                }).then(res => {
                    this.payLoading = false
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.$toast.fail(res.data.msg);
                        return
                    }
                    var order = res.data.data
                    console.log(order)
                    console.log("开始")
                    wx.chooseWXPay({
                        timestamp: order.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: order.nonce_str, // 支付签名随机串，不长于 32 位
                        package: order.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: order.sign_type, // 签名方式，默认为"SHA1"，使用新版支付需传入"MD5"
                        paySign: order.pay_sign, // 支付签名
                        success: (payRes) => {
                            this.payLoading = true
                            // 支付成功后的回调函数
                            console.log(payRes)
                            console.log("支付成功")
                            if (payRes.errMsg === "chooseWXPay:ok") {
                                // location.reload()
                                this.payLoadingText="正在为您获取支付结果，请稍后"
                                this.payLoading=true
                                const that = this
                                this.timer_pay_info = setInterval(()=>{
                                    that.getPayInfo(order.order_id)
                                }, 1000);


                            } else if (payRes.errMsg === "chooseWXPay:cancel") {
                                this.$dialog.alert({title: '支付结果', message: "您取消了支付"})
                                console.log(payRes)
                            } else {
                                this.$dialog.alert({title: '支付结果', message: "您取消了支付" + res.errMsg})
                                console.log(payRes)
                            }
                        }
                    });
                });
            },

            bindingCdKey(){
                this.$http.post("/wechat/cd_key/binding", {
                    number: this.number
                }).then(res => {
                    console.log(res)
                    if (200 !== res.data.code){
                        this.$dialog.alert({title:"提示",message:res.data.msg})
                        return
                    }
                    this.$dialog.alert({title:"提示",message:"绑定成功"})
                    this.number = ""
                });
            },

            getPayInfo(order_id){
                this.$http.get("/wechat/buy/info", {params: {order_id:order_id}}).then(payDetailsRes => {
                    if (200 === payDetailsRes.data.code) {
                        this.payLoading = false
                        clearTimeout(this.timer_pay_info);

                        this.$dialog.alert({title: '支付结果', message: "支付成功"}).then(() => {
                            //如果买的是充值卡，跳充值卡页面
                            if ( 2=== this.form_type){
                                this.$router.push('/cd_key');
                            }else {
                                window.location.host="/buy"
                            }
                        });
                    }
                });
            }
        }
    }
</script>
